import { Injectable, inject } from '@angular/core';
import { NativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';

@Injectable()
export class BrDateAdapter extends NativeDateAdapter {
  constructor() {
    super(inject(MAT_DATE_LOCALE, { optional: true }) ?? 'pt-BR', inject(Platform));
  }

  override parse(value: string | number | null | undefined): Date | null {
    if (typeof value === 'number') return new Date(value);
    if (!value) return null;

    const ddmmyyyy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(String(value));
    if (ddmmyyyy) {
      return new Date(+ddmmyyyy[3], +ddmmyyyy[2] - 1, +ddmmyyyy[1]);
    }

    const parsed = new Date(Date.parse(String(value)));
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  override format(date: Date, displayFormat: string | object): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }
}

export const BR_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
